const u = (id) => `https://images.unsplash.com/photo-${id}?w=1200&h=675&fit=crop`;
const gen = (h) => `https://static.prod-images.emergentagent.com/jobs/6dc3909f-878c-4eee-8cfe-c2f27fad2cc4/images/${h}.jpeg`;

export const SLUG_COVERS = {
  "ai-agents-economic-actors": u("1750969185331-e03829f72c7d"),
  "universities-rethink-roi": u("1758518727707-b023e285b709"),
  "entry-level-career-ladder": u("1758518729696-884228731fce"),
  "governments-ai-workforce": u("1771793231904-a516cd3baff4"),
  "tools-to-teammates": u("1782330300409-f6c1ae5f64cb"),
  "geography-of-opportunity": u("1681949287382-052ea3954a51"),
  "schools-ai-economy": gen("c72b09e4c3a9a8af0f8601165bd45cccb7caa2cae885b9f1b7c78cff41828ef1"),
  "skills-2030": gen("9cf6489a10645c84abf848bc022ce577c80c542b06c9e261e2ff537890d14f59"),
};

const C = SLUG_COVERS;
const AI_POOL = [u("1770486036751-e55247238964"), u("1770968476272-69e3e4af5df7"), u("1764258058101-47aa0a3a06a3"), C["ai-agents-economic-actors"], C["tools-to-teammates"]];
const EDU_POOL = [u("1606761568499-6d2451b23c66"), u("1758270704522-f091f8064a81"), C["universities-rethink-roi"], C["schools-ai-economy"]];
const WORK_POOL = [u("1606857521015-7f9fcf423740"), u("1758520145175-aa3b593b81af"), u("1541746972996-4e0b0f43e02a"), C["entry-level-career-ladder"], C["skills-2030"]];
const POLICY_POOL = [u("1672264597620-d792bb6de88d"), u("1610026378085-15d0e8f685db"), C["governments-ai-workforce"]];
const ECON_POOL = [u("1526642591341-bcfc36ffae2f"), u("1765741836950-76bc831f380e"), C["geography-of-opportunity"]];

export const CATEGORY_IMAGES = {
  "Artificial Intelligence": AI_POOL, "AI": AI_POOL, "Responsible AI": AI_POOL, "Adaptive Intelligence": AI_POOL,
  "Education": EDU_POOL, "Skills": [...EDU_POOL, ...WORK_POOL],
  "Future of Work": WORK_POOL, "Work": WORK_POOL, "Workforce": WORK_POOL, "Leadership": [...WORK_POOL, ...POLICY_POOL],
  "Policy": POLICY_POOL, "Economy": ECON_POOL,
};
export const ALL_IMAGES = [...new Set(Object.values(CATEGORY_IMAGES).flat())];

export const hash = (s) => [...s].reduce((h, c) => (h * 31 + c.charCodeAt(0)) >>> 0, 0);

export const coverFor = ({ slug = "", title = "", category, featured_image }) => {
  if (featured_image) return featured_image;
  if (SLUG_COVERS[slug]) return SLUG_COVERS[slug];
  const pool = CATEGORY_IMAGES[category] || ALL_IMAGES;
  return pool[hash(slug || title) % pool.length];
};
